import { NonIdealState } from '@blueprintjs/core'
import React, { SFC } from 'react'
import { RouteComponentProps } from 'react-router'

import { links } from '../../app.links'
import { Button } from '../../shared'

import './not-authorized.scss'

export type Props = RouteComponentProps<{}>

export const NotAuthorized: SFC<Props> = () => {
  return (
    <div className="not-authorized">
      <NonIdealState
        title="403 - Not Authorized"
        description="Sorry. You don't have access rights! Please contact your HR administrator."
        icon="ban-circle"
        action={<Button to={links.auth.home()}>Go back to login page</Button>}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/app/auth/components/not-authorized.tsx